import {DateTime} from "luxon"
import {monthGenitiveList, weekdaysList} from "@/plugins/consts"

export const schedule = {
  state: {
    scheduleId: null,
    scheduleList: []
  },
  mutations: {
    setScheduleId(state, val) {
      state.scheduleId = val
    },
    setScheduleList(state, val) {
      state.scheduleList = val.map(it => {
        let luxonDate = DateTime.fromFormat(it.scheduleDate, 'yyyy-MM-dd')
        let scheduleX = {
          date: `${luxonDate.toFormat('dd')} ${monthGenitiveList[luxonDate.month - 1]}, ${weekdaysList[luxonDate.weekday - 1]}`,
          dateIso: it.scheduleDate,
          times: []
        }
        for (const time of it.times) {
          const scheduleTimeString = DateTime.fromFormat(time.scheduleTime, 'HH:mm:ss').toFormat('HH:mm')
          scheduleX.times.push({
            id: time.scheduleId,
            time: scheduleTimeString
          })
        }
        return scheduleX
      })
    }
  },
  getters: {
    scheduleId(state) {
      return state.scheduleId
    },
    scheduleList(state) {
      return state.scheduleList
    },
    scheduleInfo(state) {
      for (const date of state.scheduleList) {
        for (const time of date.times) {
          if (time.id === state.scheduleId) {
            const dateString = DateTime.fromFormat(date.dateIso, 'yyyy-MM-dd').toFormat('dd.MM.yyyy')
            return `${dateString} в ${time.time}`
          }
        }
      }
      return ''
    }
  }
}